import { getApi } from './common/apis';

export default class OutdatedEmailsService {
    /**
     * Get vendor partner contacts whose email addresses are on the RFP suppression list.
     * Site-admin only. Returns { success, count, rows: [...] }.
     */
    async getOutdatedVendorEmails() {
        return await getApi('v1/outdated-vendor-emails');
    }

    /**
     * Get platform admins (site + channel) whose email addresses are on the RFP suppression list.
     * Site-admin only. Returns { success, count, rows: [...] }.
     */
    async getOutdatedAdminEmails() {
        return await getApi('v1/outdated-admin-emails');
    }
}